import { services } from '../../../../API';
import { BaseLayersStore } from '../../../../store/BaseLayersStore';
import { MapStore } from '../../../../store/Map';
import { Card } from '../../../../store/LinkController/Card';
import { IRecordCardController } from '../../../../store/LinkController/types';
import {
  MouseController,
  TableCardMouseControllerLink,
} from '../../../../store/MouseController';
import { RecordCardManager } from '../../../../store/shared/RecordCardManager';
import { BrowserHistoryToCardLink } from '../../../../store/LinkController/BrowserHistoryToCard';
import { INIT_MAP_DATA } from '@project/store';

export class MapWidgetRootStore {
  static PROJECTION = INIT_MAP_DATA.srid;

  readonly map: MapStore;
  readonly baseLayers: BaseLayersStore;
  readonly mouseController: MouseController;

  readonly recordCardManager: RecordCardManager;
  readonly recordCard: IRecordCardController;
  readonly recordCardMouseController: TableCardMouseControllerLink;

  readonly browserHistoryCard: BrowserHistoryToCardLink;

  constructor(
    zoom: number,
    center: number[],
    enableRotation: boolean,
    initialRotation: number,
  ) {
    this.map = new MapStore(
      MapWidgetRootStore.PROJECTION,
      zoom,
      center,
      enableRotation,
      initialRotation,
    );
    this.baseLayers = new BaseLayersStore(
      services,
      this.map.mapProperties,
      this.map.layerCollection,
    );

    this.mouseController = new MouseController(
      this.map.userActivityManager,
      this.map.mapProperties,
    );

    this.recordCard = new Card();
    this.recordCardManager = new RecordCardManager(services);
    this.recordCardMouseController = new TableCardMouseControllerLink(
      this.mouseController,
      this.recordCard,
      this.map.layerCollection,
    );

    this.browserHistoryCard = new BrowserHistoryToCardLink(this.recordCard);
  }
}
